import { makeStyles } from '@material-ui/core'
import Trovity from 'src/assets/Buy_Policy_Images/TrovityImage.svg'
import BGTrovityLogo from 'src/assets/Buy_Policy_Images/BGTrovityLogo.svg'
import ArrowRight from 'src/assets/Buy_Policy_Images/ArrowRight.svg'
import ArrowLeft from 'src/assets/Buy_Policy_Images/ArrowLeft.svg'
import { COLORS } from 'src/utils/Themes/colors'
import { Carousel } from 'react-responsive-carousel'
import { TROVITY_ASSURANCE_LIST } from 'src/utils/constants/BuyPolicy'

const AssistanceClaim = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.backgroundContainer}>
          <img src={BGTrovityLogo} alt='Trovity' />
        </div>
        <div className={classes.mainContainer}>
          <div className={classes.mainContent}>
            <div className={classes.headingContainer}>
              <img src={Trovity} alt='Trovity' />
              <span className={classes.assuredText}>Claim AssureGuard</span>
              <span className={classes.partnerText}>
                Your Trusted Health Insurance Claim Partner
              </span>
            </div>

            <div className={classes.carouselContainer}>
              <Carousel
                infiniteLoop={true}
                showArrows={true}
                showStatus={false}
                showThumbs={false}
                showIndicators={false}
                autoPlay={true}
                stopOnHover={true}
                renderArrowPrev={(clickHandler, hasPrev) => {
                  return (
                    <div
                      className={`${hasPrev ? 'absolute' : 'hidden'} ${
                        classes.arrowIconContainer
                      }`}
                      onClick={clickHandler}
                    >
                      <img src={ArrowLeft} alt='Previous' />
                    </div>
                  )
                }}
                renderArrowNext={(clickHandler, hasNext) => {
                  return (
                    <div
                      className={`${hasNext ? 'absolute' : 'hidden'} ${
                        classes.arrowIconContainer
                      }`}
                      onClick={clickHandler}
                    >
                      <img src={ArrowRight} alt='Next' />
                    </div>
                  )
                }}
              >
                {TROVITY_ASSURANCE_LIST?.map((assuranceListItem) => (
                  <div
                    key={`assuranceListItem_${assuranceListItem?.id}`}
                    className={classes.assuranceListItem}
                  >
                    <span className={classes.assuranceTitle}>
                      {assuranceListItem?.title}
                    </span>
                    <ul className={classes.assuranceListContainer}>
                      {assuranceListItem?.assuranceItems?.map(
                        (assuranceItem) => (
                          <li
                            key={`assuranceItem_${assuranceItem?.id}`}
                            className={classes.assuranceDescription}
                          >
                            {assuranceItem?.description}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.footer}>
        &apos;* Regardless of where you purchased your insurance, we&apos;re
        here to support your claim&apos;
      </div>
    </div>
  )
}
export default AssistanceClaim
const useStyles = makeStyles({
  container: {
    display: 'flex',
    background: 'rgba(239, 102, 155, .2)',
    margin: '25px 0px',
    flexDirection: 'column',
    borderRadius: '10px',
  },
  content: {
    position: 'relative',
    border: '1px solid #EF669B',
    background: COLORS.WHITE,
    width: 'calc(100% - 2px)',
    height: '100%',
    borderRadius: '10px',
  },
  backgroundContainer: {
    width: '100%',
    height: '100%',
  },
  mainContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    width: '100%',
    height: '100%',
  },
  mainContent: {
    padding: '25px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  headingContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  assuredText: {
    fontSize: '23px',
    color: '#B92250',
    fontStyle: 'italic',
    fontWeight: '700 !important',
  },
  partnerText: {
    fontSize: '16px',
    color: '#090909',
    fontStyle: 'italic',
    fontWeight: '500 !important',
  },
  arrowIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  arrowIcon: {
    height: '16px',
    width: '44px',
  },
  carouselContainer: {
    margin: '20px 0',
  },
  assuranceListItem: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 20px',
  },
  assuranceTitle: {
    fontSize: '19px',
    color: '#B92250',
    fontWeight: 'bold',
  },
  assuranceListContainer: {
    listStyle: 'disc',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  assuranceDescription: {
    fontSize: '16px',
    textAlign: 'left',
  },
  footer: {
    fontSize: '14px',
    color: '#B92250',
    fontWeight: 'bold',
    padding: '10px',
    textAlign: 'center',
  },
})
